export const homeRouters = [
  {
    name: "HomePage",
    path: "/",
    component: () => import("../../views/Home.vue"),
  },
];
